<script setup lang="ts">
import type { Component } from 'vue'
import { BellIcon, TrophyIcon, UserCircleIcon, UsersIcon } from '@heroicons/vue/24/outline'

interface SettingsNavLink {
  label: string
  to: string
  icon: Component
}

const settingsNav: SettingsNavLink[] = [
  {
    label: 'Account Details',
    to: '/settings',
    icon: UserCircleIcon,
  },
  {
    label: 'Team',
    to: '/settings/team',
    icon: UsersIcon,
  },
  {
    label: 'Leaderboard Opt-Ins',
    to: '/settings/leaderboard-opt-ins',
    icon: TrophyIcon,
  },
  {
    label: 'Notifications',
    to: '/settings/notifications',
    icon: BellIcon,
  },
]
</script>

<template>
  <div data-layout="settings">
    <NuxtLoadingIndicator />
    <NuxtLayout name="dashboard">
      <template #sidebar>
        <div
          class="flex flex-col justify-start h-full gap-2 border-r border-default w-57 px-2 py-4"
        >
          <nav class="text-xs">
            <ul class="space-y-1">
              <li v-for="item in settingsNav" :key="item.to">
                <NuxtLink
                  :to="item.to"
                  class="h-8 flex items-center w-full gap-2 py-2 px-2 hover:bg-neutral-600/30 transition rounded-lg text-secondary"
                  exact-active-class="bg-neutral-600/30"
                >
                  <component :is="item.icon" class="size-3.5 shrink-0 text-secondary" aria-hidden="true" />
                  <div class="grow text-left">
                    {{ item.label }}
                  </div>
                </NuxtLink>
              </li>
            </ul>
          </nav>
        </div>
      </template>
      <div class="min-h-[60vh] flex flex-col items-center">
        <slot />
      </div>
    </NuxtLayout>
  </div>
</template>
